export { FinalizationRegistry } from "./FinalizationRegistry.js";
